module.exports = __webpack_public_path__ + "static/media/rothberry.53521516.jpg";